import { BulkMessage } from "@/__generated__/graphql";

export function isActive(
  bulkMessage: BulkMessage | undefined,
  now: number,
): boolean {
  if (!bulkMessage) {
    return false;
  }
  const startTime = bulkMessage?.startSendingAt;
  const stopTime = bulkMessage?.stopSendingAt;

  if (startTime && stopTime) {
    return startTime <= now && stopTime > now;
  }
  return false;
}

export function isSent(bulkMessage: BulkMessage, now: number) {
  const startTime = bulkMessage.startSendingAt;
  const stopTime = bulkMessage.stopSendingAt;

  if (stopTime) {
    return stopTime < now;
  } else if (startTime) {
    return startTime < now;
  }

  return true;
}
